import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const problems = [{
    problem: 'Recetas de YouTube que nunca te quedan igual',
    cost: 'Ingredientes tirados, plata perdida'
  }, {
    problem: 'La masa se quiebra o no agarra el aroma',
    cost: 'Producción arruinada, frustración'
  }, {
    problem: 'Los sahumerios se apagan solos al prenderlos',
    cost: 'Clientes insatisfechos, sin recompras'
  }, {
    problem: 'No sabés cuánto cobrar',
    cost: 'Trabajás horas y prácticamente regalás todo'
  }, {
    problem: 'El packaging te da vergüenza',
    cost: 'No podés mostrar el producto en Instagram'
  }, {
    problem: 'Sin sistema de ventas online',
    cost: 'Nunca llegás a clientes nuevos'
  }, {
    problem: 'Otro fin de semana sin vender nada',
    cost: 'El mismo ciclo, el mes que viene'
  }];
  return <section className="w-full bg-[#FDF1E4] donut-pattern py-4 md:py-8 relative" data-id="element-150">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-152">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3D2817] text-center mb-2 md:mb-4 leading-tight" data-id="element-153">
            ¿Cuántos fines de semana más vas a pasar mirando videos de
            sahumerios sin animarte a empezar?
          </h2>

          <div className="text-center mb-3 md:mb-5 space-y-1 md:space-y-2" data-id="element-154">
            <p className="text-lg text-[#6B5747] leading-relaxed" data-id="element-155">
              Querés tener tu propio negocio. Algo tuyo. Algo que podés hacer
              desde casa, a tu ritmo, con tus propias manos. Pero cada vez que
              intentás arrancar, aparece lo mismo:
              <br data-id="element-156" />
              <br data-id="element-157" />
              La masa no te queda. Los sahumerios se quiebran al secarlos. No
              sabés cuánto cobrar. Y terminás pensando que "capaz no es para
              vos".
            </p>
            <p className="text-xl md:text-2xl font-bold text-[#B45309]" data-id="element-158">
              No es falta de talento. Es falta de un sistema.
            </p>
          </div>

          <div className="mb-3 md:mb-5" data-id="element-159">
            <h3 className="text-2xl font-bold text-[#3D2817] mb-2 md:mb-3 text-center" data-id="element-160">
              ❌ Lo que pasa sin el Mega Pack:
            </h3>
            <div className="bg-white border border-[#E8D5BA] rounded-lg overflow-hidden shadow-sm" data-id="element-161">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 bg-[#FAF1E4] border-b border-[#E8D5BA]" data-id="element-162">
                <div className="font-bold text-[#3D2817] text-sm" data-id="element-163">
                  ❌ El problema
                </div>
                <div className="font-bold text-[#B85450] text-sm" data-id="element-164">
                  💸 El costo real
                </div>
              </div>
              {problems.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.08,
              duration: 0.4
            }} className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 border-b border-[#F0E3CE] last:border-b-0" data-id="element-165">
                  <div className="flex items-start gap-2" data-id="element-166">
                    <XIcon className="w-4 h-4 text-[#D4937A] flex-shrink-0 mt-0.5" data-id="element-167" />
                    <p className="text-[#6B5747] text-sm" data-id="element-168">{item.problem}</p>
                  </div>
                  <div className="text-[#B85450] font-semibold text-sm md:pl-0 pl-6" data-id="element-169">
                    {item.cost}
                  </div>
                </motion.div>)}
            </div>
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-[#B45309] text-center" data-id="element-170">
            ¿Y si esta fuera la última semana que pasó así?
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}